import React from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import ForwardIcon from '@mui/icons-material/Forward';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DownloadIcon from '@mui/icons-material/Download';
import ReplyIcon from '@mui/icons-material/Reply';
import PushPinIcon from '@mui/icons-material/PushPin';
import DeleteIcon from '@mui/icons-material/Delete';

export interface MessageActionMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  showForward: boolean;
  showCopy: boolean;
  showDownload: boolean;
  showReply: boolean;
  showPin: boolean;
  pinLabel?: string;
  showDelete: boolean;
  onForward: () => void;
  onCopy: () => void;
  onDownload: () => void;
  onReply: () => void;
  onPin: () => void;
  onDelete: () => void;
}

export const MessageActionMenu: React.FC<MessageActionMenuProps> = ({
  anchorEl,
  open,
  onClose,
  showForward,
  showCopy,
  showDownload,
  showReply,
  showPin,
  pinLabel = 'Pin',
  showDelete,
  onForward,
  onCopy,
  onDownload,
  onReply,
  onPin,
  onDelete,
}) => (
  <Menu
    anchorEl={anchorEl}
    open={open}
    onClose={onClose}
    PaperProps={{ sx: { borderRadius: 2, minWidth: 220 } }}
  >
    {showForward && (
      <MenuItem onClick={onForward} sx={{ fontSize: '0.88rem' }}>
        <ListItemIcon>
          <ForwardIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Forward to community…</ListItemText>
      </MenuItem>
    )}
    {showCopy && (
      <MenuItem onClick={onCopy} sx={{ fontSize: '0.88rem' }}>
        <ListItemIcon>
          <ContentCopyIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Copy</ListItemText>
      </MenuItem>
    )}
    {showDownload && (
      <MenuItem onClick={onDownload} sx={{ fontSize: '0.88rem' }}>
        <ListItemIcon>
          <DownloadIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Save to downloads</ListItemText>
      </MenuItem>
    )}
    {showReply && (
      <MenuItem onClick={onReply} sx={{ fontSize: '0.88rem' }}>
        <ListItemIcon>
          <ReplyIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Reply</ListItemText>
      </MenuItem>
    )}
    {showPin && (
      <MenuItem onClick={onPin} sx={{ fontSize: '0.88rem' }}>
        <ListItemIcon>
          <PushPinIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>{pinLabel}</ListItemText>
      </MenuItem>
    )}
    {showDelete && (
      <MenuItem onClick={onDelete} sx={{ fontSize: '0.88rem', color: '#d32f2f' }}>
        <ListItemIcon>
          <DeleteIcon fontSize="small" sx={{ color: '#d32f2f' }} />
        </ListItemIcon>
        <ListItemText primaryTypographyProps={{ color: '#d32f2f' }}>
          Delete for everyone
        </ListItemText>
      </MenuItem>
    )}
  </Menu>
);
